import ForgotPassword from './ForgotPassword.js';

export const ForgotPasswordConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/forgotpassword',
            component: ForgotPassword
        }
    ]
};


// WEBPACK FOOTER //
// ./src/main/content/forgot-password/ForgotPasswordConfig.js